import axios from "axios";

export const signup = ({
  email,
  firstName,
  lastName,
  password1,
  password2,
  bio,
  role,
}) => {
  return axios.post("/users/auth/registration/", {
    email: email,
    first_name: firstName,
    last_name: lastName,
    password1: password1,
    password2: password2,
    bio: bio,
    role: role,
  });
};
